import { ECreditApplicationStep } from '@if/core/types'
import { FilteredCreditApplication } from '@src/api/credit-api'
import UploadFilesTable from '@src/components/UploadFilesTable'
import { hasMissingDocuments } from '@src/data/credit-application-selectors'
import { useTranslation } from 'react-i18next'
import UnderReviewTile from '../../components/UnderReviewTile'

interface Props {
  creditApp: FilteredCreditApplication
}
const RequiredDocForDecisionForm = ({ creditApp }: Props) => {
  const { t } = useTranslation()
  const hasMissingDocs = hasMissingDocuments(creditApp, ECreditApplicationStep.Credit)

  return hasMissingDocs ? (
    <main className="general-message">
      {hasMissingDocs && (
        <div>
          <h4 className="subtitle">{t('common.financeApplication')}</h4>
          <h1>{t('decision.creditDocumentRequiredTitle')}</h1>
          <div className="paragraph">
            <p>{t('decision.creditDocumentRequired')}</p>
            <p>{t('identity.notifyEmail')}</p>
          </div>
          <UploadFilesTable creditApp={creditApp} />
        </div>
      )}
    </main>
  ) : (
    <UnderReviewTile />
  )
}

export default RequiredDocForDecisionForm
